import {
  GET_PLC_SAFETY_TRIGGER_BY_ID,
  GET_PLC_SAFETY_TRIGGER_BY_ID_SUCCESS,
  GET_PLC_SAFETY_TRIGGER_BY_ID_ERROR,
} from './actionTypes';

export const getPlcSafetyTriggerById = (user, triggerId) => ({
  type: GET_PLC_SAFETY_TRIGGER_BY_ID,
  payload: { user, triggerId },
});

export const getPlcSafetyTriggerByIdSuccess = (trigger) => ({
  type: GET_PLC_SAFETY_TRIGGER_BY_ID_SUCCESS,
  payload: { trigger },
});

export const getPlcSafetyTriggerByIdError = (error) => ({
  type: GET_PLC_SAFETY_TRIGGER_BY_ID_ERROR,
  payload: error,
});
